module.exports = __webpack_public_path__ + "img/fieldwork_methods.7b57831f.png";